export function PageTitle(title: string) {
    return document.title = `${title}`
}